const fifteen = [
  {
    name: 'buying',
    type: '15',
    size: '15px'
  },
  {
    name: 'checkbox',
    type: '15',
    size: '15px'
  },
  {
    name: 'chevron-down',
    type: '15',
    size: '15px'
  },
  {
    name: 'chevron-up',
    type: '15',
    size: '15px'
  },
  {
    name: 'clear',
    type: '15',
    size: '15px'
  },
  {
    name: 'clear-fill',
    type: '15',
    size: '15px'
  },
  {
    name: 'close',
    type: '15',
    size: '15px'
  },
  {
    name: 'collapse',
    type: '15',
    size: '15px'
  },
  {
    name: 'drag-grip',
    type: '15',
    size: '15px'
  },
  {
    name: 'expand',
    type: '15',
    size: '15px'
  },
  {
    name: 'external-page',
    type: '15',
    size: '15px'
  },
  {
    name: 'hot-deals-fill',
    type: '15',
    size: '15px'
  },
  {
    name: 'information',
    type: '15',
    size: '15px'
  },
  {
    name: 'more-actions',
    type: '15',
    size: '15px'
  },
  {
    name: 'rejected',
    type: '15',
    size: '15px'
  },
  {
    name: 'search',
    type: '15',
    size: '15px'
  },
  {
    name: 'selling',
    type: '15',
    size: '15px'
  },
  {
    name: 'sort-disable',
    type: '15',
    size: '15px'
  },
  {
    name: 'sort-down',
    type: '15',
    size: '15px'
  },
  {
    name: 'sort-up',
    type: '15',
    size: '15px'
  },
  {
    name: 'star-fill',
    type: '15',
    size: '15px'
  }
];

export default fifteen;



// WEBPACK FOOTER //
// ./src/containers/foundations/Icons/constants/fifteen.js